module.exports = fox._r("images/reg-step2-bg.jpeg", __webpack_public_path__ + "_/_/_/common/frame/images/reg-step2-bg.jpeg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/reg-step2-bg.jpeg
// module id = 136
// module chunks = 2